import { ApiProperty } from "@nestjs/swagger";

export class PlantRoleRequest {
    @ApiProperty()
    role: string;
    @ApiProperty()
    unitId: number;
    constructor(role: string, unitId: number) {
        this.role = role;
        this.unitId = unitId;
    }
}
